/*
  Adventsonntage – Kerzen anzünden (sections/ec-advent-sundays.liquid, Deadline-Sektion)
  Sobald ein Kranz ins Bild kommt, zünden sich seine Kerzen nacheinander an.
  Mehrere Kränze, die gleichzeitig sichtbar werden, warten aufeinander:
  Kerze für Kerze, Sonntag für Sonntag. Bei reduzierter Bewegung brennt alles sofort.
*/
(function () {
  if (window.ECAdventCandles) return;
  window.ECAdventCandles = true;

  var STEP = 380;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var nextAt = 0;

  function lightAll(wreath) {
    wreath.querySelectorAll('.ec-adv-candle--on').forEach(function (c) { c.classList.add('is-lit'); });
  }

  function lightInOrder(wreath) {
    var candles = wreath.querySelectorAll('.ec-adv-candle--on:not(.is-lit)');
    var start = Math.max(Date.now() + 120, nextAt);
    candles.forEach(function (candle, i) {
      setTimeout(function () { candle.classList.add('is-lit'); }, start - Date.now() + i * STEP);
    });
    nextAt = start + candles.length * STEP + 160;
  }

  function init() {
    var wreaths = document.querySelectorAll('[data-adv-light] .ec-adv-wreath');
    if (!wreaths.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      wreaths.forEach(lightAll);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries
        .filter(function (e) { return e.isIntersecting; })
        .sort(function (a, b) { return a.boundingClientRect.top - b.boundingClientRect.top || a.boundingClientRect.left - b.boundingClientRect.left; })
        .forEach(function (entry) {
          io.unobserve(entry.target);
          lightInOrder(entry.target);
        });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.6 });
    wreaths.forEach(function (w) { io.observe(w); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
